import { api, ENDPOINTS } from '../config';
import { SolarFilters, SolarResponse, SolarResponseData } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getSolar(filters?: SolarFilters): Promise<SolarResponseData> {
  const response = await api.get<SolarResponse>(ENDPOINTS.SOLAR, {
    params: filters,
  });
  
  return response.data;
}